require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2006-03-27-why-sip-sucks.json") })
        }
      }, "path---articles-2006-03-27-why-sip-sucks");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2006-03-27-why-sip-sucks!./.cache/json/articles-2006-03-27-why-sip-sucks.json
// module id = 461
// module chunks = 231608221292675